module.exports = ['$scope', '$translate', function ($scope, $translate) {
        console.error($translate.instant('uaa.handles-403-loop.detail'));
    }];


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/components/on403Loop/on403LoopCtrl.js
// module id = 406
// module chunks = 0